import axios from 'axios';
import { UPDATE_STEP } from '../paths';

export const updateStep = async (data, courseStepID) => {
  const { properties, points, exam, examLength } = data;
  const body = {
    courseStepID,
    title: properties.title,
    type: properties.type.value,
    stepTime: properties.stepTime * 1 || undefined,
    mediaHash: properties.type.value === 2 || properties.type.value === 1 ? properties.content : undefined,
    mediaDescription: properties.description,
    html: properties.type.value === 3 ? properties.html : undefined,
    slideHashes: properties.type.value === 0 ? properties.slideHashes : undefined,
    score: points.reward,
    passScore: points.required,
    examLength: examLength,
    questions: exam.map((q, index) => {
      return { number: index + 1, title: q.title, options: q.options, answer: q.answer };
    }),
    medias: properties?.medias?.map(({ name, fileName, hash, type }) => ({
      name,
      fileName,
      hash,
      type: type?.type,
    })),
  };
  const response = await axios.post(UPDATE_STEP, body);
  return response;
};
